<template>
  <Loader v-if="loading" />
  <div v-else class="content">
    <h1>Push items in SQS</h1>
    <div v-if="messages.length > 0" class="message bg-green">
      <ul>
        <li class="label" v-for="message in messages" v-text="message"></li>
      </ul>
    </div>
    <div class="control margin-top">
      <InputRow label="Queue name">
        <select v-model="queue.selected">
          <option :value="queue" v-for="queue in queues">
            {{ queue.name }}
          </option>
        </select>
      </InputRow>
    </div>
    <div class="control">
      <InputRow label="Model Ids">
        <textarea cols="50" rows="10"
                  placeholder="Add multiple model IDs in separate lines" v-model="modelIds">
        </textarea>
      </InputRow>
      <InputRow label="">
        <button class="margin-right" @click="batchCreateQueue()">Push items to queue</button>
      </InputRow>
    </div>
  </div>
</template>

<style scoped lang="less">

</style>

<script>
import Vue from 'vue'
import _ from 'lodash'

export default {
  name: "QueuePush",
  data: () => ({
    loading: false,
    queue: {
      selected: {}
    },
    messages: [],
    queues: [],
    modelIds: ""
  }),
  methods: {
    batchCreateQueue() {
      const modelIds = this.getModelIds();
      if (!this.validateRequest(modelIds)) {
        return
      }
      this.addMultipleToSqs(
        this.queue.selected,
        modelIds
      )
    },
    validateRequest(modelIds) {
      if (this.queue.selected.name === undefined) {
        alert("Please select a queue name")
        return false
      }
      if (_.isEmpty(modelIds)) {
        alert("Model IDs cannot be empty")
        return false
      }
      return true
    },
    getModelIds () {
      if (this.modelIds.length === 0) {
        return false
      }
      return _.uniq(this.modelIds.split('\n'))
    },
    addMultipleToSqs(queue, modelIds) {
      Vue.api.post('queue/push/items', {
        queue_name: queue.name,
        model_name: queue.model,
        queue_type: queue.type,
        model_ids: modelIds
      }, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        error: (error) => this.messages.push('Error !!! ' + error.data.message || ''),
        callback: (data) => this.messages.push(data.message)
      })
    },
    load () {
      Vue.api.get('/queue/info', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.queues = data
      })
    }
  },
  created () {
    this.load()
  }
}
</script>


